export default __webpack_public_path__ + "static/media/new_1.2af69a93.jpeg";